@if (facade.multiOrderBuyList$ | async; as buyList) {
  @if (buyList.length) {
    <h3 class="mb-2" data-zid="buy-list-headline">{{ 'trade.multi-order.confirm.buy.headline' | transloco }}</h3>
    <p>{{ 'trade.multi-order.confirm.hint' | transloco }}</p>
    @for (item of buyList; track item.isin) {
      <ng-container *ngTemplateOutlet="order; context: { item: item, direction: 'buy' }" />
    }
  }
}

@if (facade.multiOrderSellList$ | async; as sellList) {
  @if (sellList.length) {
    <h3 class="mb-3" data-zid="sell-list-headline">{{ 'trade.multi-order.confirm.sell.headline' | transloco }}</h3>
    @for (item of sellList; track item.isin) {
      <ng-container *ngTemplateOutlet="order; context: { item: item, direction: 'sell' }" />
    }
  }
}

<ng-template #order let-item="item" let-direction="direction">
  <h3 class="mb-3">{{ item.asset?.longName }}</h3>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.direction' | transloco }}</div>
        <div class="col text-right font-bold">{{ 'trade.multi-order.confirm.' + direction + '.label' | transloco }}</div>
      </div>
      <hr />
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.exchange' | transloco }}</div>
        <div class="col text-right font-bold">{{ item.asset?.marketName }}</div>
      </div>
      <hr />
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.validity' | transloco }}</div>
        <div class="col text-right font-bold">
          @if (direction === 'buy') {
            {{ 'trade.multi-order.confirm.label.today' | transloco }}
          } @else {
            {{ sellOrderValidToDate$ | async | date: 'shortDate' }}
          }
        </div>
      </div>
      <hr />
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.type' | transloco }}</div>
        <div class="col text-right font-bold">{{ 'trade.multi-order.confirm.label.market' | transloco }}</div>
      </div>
      <hr />
    </div>
    <div class="col-12 col-md-6">
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.quote' | transloco }}</div>
        <div class="col text-right font-bold text-nowrap">
          @if (item.quote) {
            <span class="quoteindicator-variant4" [zeroBlink]="direction === 'buy'" [val]="item.quote?.ask">{{
              item.quote?.ask | priceScale: item.asset?.priceScale
            }}</span>
            <span [class.ml-2]="direction === 'buy'"> / </span>
            <span class="quoteindicator-variant4" [zeroBlink]="direction === 'sell'" [val]="item.quote?.bid">{{
              item.quote.bid | priceScale: item.asset?.priceScale
            }}</span>
          }
        </div>
      </div>
      <hr />
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.qty' | transloco }}</div>
        <div class="col text-right font-bold">{{ item.qty }}</div>
      </div>
      <hr />
      <div class="row justify-content-between">
        <div class="col">{{ 'trade.multi-order.confirm.label.minimum-surcharge' | transloco }}</div>
        <div class="col text-right font-bold">
          @if (item.minimumSurcharge) {
            {{ item.minimumSurcharge | currency }}
          } @else {
            &mdash;
          }
        </div>
      </div>
      <hr />
      <div class="row justify-content-between">
        <div class="col text-nowrap font-bold">{{ 'trade.multi-order.confirm.label.estimated-sum' | transloco }}</div>
        <div class="col text-right font-bold">
          {{ item.estimatedSum + (direction === 'buy' ? (item.minimumSurcharge ?? 0) : -(item.minimumSurcharge ?? 0)) | currency }}
        </div>
      </div>
      <hr class="black" />
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <trade-asset-links [asset]="item.asset" />
    </div>
  </div>
  <div class="row">
    <div class="col-12" [zeroLoadingIndicator]="facade.loadingExante$ | async">
      @if (facade.loadingExante$ | async) {
        {{ 'trade.confirm.exante.loading' | transloco }}
      } @else {
        <a class="link-secondary" [href]="facade.exante$ | async | exanteUri: item.asset?.isin" target="_blank" rel="noopener noreferrer">{{
          'trade.confirm.exante.link' | transloco
        }}</a>
      }
    </div>
  </div>
  <hr class="fat" />
</ng-template>
